import { generateTransformerDemoData } from "./trans/generate_transformer_demo_data";
import { generateAhuLatestDashboardDemoData } from "./ahu/generate_ahu_get_latest_demo_dashboard_data";
import { generateAhuLatestDataDemo } from "./ahu/generate_ahu_get_latest_data_demo";
import { generateAhuAnalyticsLineDemo } from "./ahu/generate_ahu_analytics_line_demo";
import { generateThLatestDashboardDemo } from "./th_ms/generate_th_get_latest_dashboard_demo";
import { generateThMetersDemo } from "./th_ms/generate_th_meters_demo";
import { generateThSensorsDemo } from "./th_ms/generate_th_sensors_demo";
import { generateThGetLatestDataDemo } from "./th_ms/generate_th_get_latest_data_demo";
import { generateThChartYearlyDemo } from "./th_ms/generate_th_chart_yearly_demo";
import {generateThLineDemo} from "./th_ms/generate_th_line_demo";
import {generateThChartMonthlyDemo} from "./th_ms/generate_th_chart_monthly_demo";
import {generateAqiIndoorLatestDashboardDemo} from "./temp_indoor/generate_aqi_indoor_latest_dashboard_demo";
import {generateAqiIndoorMetersDemo} from "./temp_indoor/generate_aqi_indoor_meters_demo";
import {generateAqiIndoorGetLatestDataDemo} from "./temp_indoor/generate_aqi_indoor_get_latest_data_demo";
import {generateAqiIndoorLineDemo} from "./temp_indoor/generate_aqi_indoor_line_demo";
import {generateAqiIndoorChartMonthDemo} from "./temp_indoor/generate_aqi_indoor_chart_month_demo";
import {generateAqiIndoorChartYearDemo} from "./temp_indoor/generate_aqi_indoor_chart_year_demo";
import {generateVibrationLatestListDemo} from "./vib/generate_vibration_get_latest_list_demo";
import {generateVibrationDefaultMeterDemo} from "./vib/generate_vibration_default_meter_demo";
import {generateVibrationGetLatestDataDemo} from "./vib/generate_vibration_get_latest_data_demo";
import {generateVibrationLastFifteenDemo} from "./vib/generate_vibration_last_fifteen_demo";
import {generateVibrationAiAnalysisAllDemo} from "./vib/generate_vibration_ai_analysis_all_demo";
import {generateVibrationChartMonthDemo} from "./vib/generate_vibration_chart_month_demo";
import {generateVibrationChartYearDemo} from "./vib/generate_vibration_chart_year_demo";
import {generateBmsMetersDemo} from "./ups_whole_bank/generate_bms_meters_demo";
import {generateBmsLatestDataDemo} from "./ups_whole_bank/generate_bms_latest_data_demo";
import {generateBmsLineDemo} from "./ups_whole_bank/generate_bms_line_demo";
import {generate_pump_latest_dashboard_demo} from "./pump_ms/generate_pump_latest_dashboard_demo";
import {generate_pump_latest_data_demo} from "./pump_ms/generate_pump_latest_data_demo";
import {generate_pump_analytics_line_demo} from "./pump_ms/generate_pump_analytics_line_demo";
import {generate_busbar_locations_demo} from "./busbar/generate_busbar_locations_demo";
import {generate_busbar_sensors_demo} from "./busbar/generate_busbar_sensors_demo";
import {generate_busbar_latest_dashboard_demo} from "./busbar/generate_busbar_latest_dashboard_demo";
import {generate_busbar_latest_data_demo} from "./busbar/generate_busbar_latest_data_demo";
import {generate_busbar_line_demo} from "./busbar/generate_busbar_line_demo";
import {generate_busbar_year_chart_demo} from "./busbar/generate_busbar_year_chart_demo";
import {generate_busbar_month_chart_demo} from "./busbar/generate_busbar_month_chart_demo";
import {outdoor_registry} from "./temp_outdoor/outdoor_registry";
import {generate_outdoor_latest_dashboard_demo} from "./temp_outdoor/generate_outdoor_latest_dashboard_demo";
import {generate_outdoor_latest_data_demo} from "./temp_outdoor/generate_outdoor_latest_data_demo";
import {generate_outdoor_meters_demo} from "./temp_outdoor/generate_outdoor_meters_demo";
import {generate_outdoor_line_chart_demo} from "./temp_outdoor/generate_outdoor_line_chart_demo";
import {generate_outdoor_month_chart_demo} from "./temp_outdoor/generate_outdoor_month_chart_demo";
import {generate_outdoor_year_chart_demo} from "./temp_outdoor/generate_outdoor_year_chart_demo";
import {generate_sankey_day_demo} from "./ems/generate_sankey_day_demo";
import {generate_ems_status_demo} from "./ems/generate_ems_status_demo";
import {generate_ems_datatable_demo} from "./ems/generate_ems_datatable_demo";
import {generate_ems_month_bar_chart_demo} from "./ems/generate_ems_month_bar_chart_demo";

// ------------------------------
// YEAR-BASED TH CHART REGISTRY
// ------------------------------

// ------------------------------
// MAIN DEMO REGISTRY
// ------------------------------
export const demoRegistry = {
    // Transformer
    "transformer/latest_data": (params) => generateTransformerDemoData(params.meter_id),

    // AHU
    "ahu_ms/get_latest_dashboard": () => generateAhuLatestDashboardDemoData(),
    "ahu_ms/get_latest_data": (params) => generateAhuLatestDataDemo(params?.meter_id),
    "ahu_ms/analytics/line": (params) => generateAhuAnalyticsLineDemo(params),

    // TH
    "th_ms/get_latest_dashboard": () => generateThLatestDashboardDemo(),
    "th_ms/meters": () => generateThMetersDemo(),
    "th_ms/sensors": (params) => generateThSensorsDemo(params?.meter_id),
    "th_ms/get_latest_data": (params) => generateThGetLatestDataDemo({meter_id: Number(params?.meter_id), sensor_name: Number(params?.sensor_name),}),
    "th_ms/chart/year": (params) => generateThChartYearlyDemo({meter_id: Number(params?.meter_id), sensor_name: Number(params?.sensor_name),year:params.year}),
    "th_ms/chart/month": (params) => generateThChartMonthlyDemo({meter_id: Number(params?.meter_id), sensor_name: Number(params?.sensor_name),year:params.year,month:params.month}),
    "th_ms/line": (params) => generateThLineDemo({meter_id: Number(params?.meter_id), sensor_name: Number(params?.sensor_name), start: params?.start, end: params?.end,}),

    //temp indoor
    "aqi/indoor_get_latest_dashboard": () => generateAqiIndoorLatestDashboardDemo(),
    "aqi/indoor_meters": () => generateAqiIndoorMetersDemo(),
    "aqi/indoor_get_latest_data": (params) => generateAqiIndoorGetLatestDataDemo({meter_id: Number(params?.meter_id),}),
    "aqi/indoor_line": (params) => generateAqiIndoorLineDemo({meter_id: Number(params?.meter_id),start: params?.start, end: params?.end,}),
    "aqi/indoor_chart/month": (params) => generateAqiIndoorChartMonthDemo({meter_id: Number(params?.meter_id), year: Number(params?.year), month: Number(params?.month),}),
    "aqi/indoor_chart/year": (params) => generateAqiIndoorChartYearDemo({meter_id: Number(params?.meter_id), year: Number(params?.year),}),


    //vibration
    "vibration/get_latest_list": () => generateVibrationLatestListDemo(),
    "vibration/default_meter": (params) => generateVibrationDefaultMeterDemo({meter_id: Number(params?.meter_id),}),
    "vibration/get_latest_data": (params) => generateVibrationGetLatestDataDemo({meter_id: Number(params?.meter_id),}),
    "vibration/last_fifteen": (params) => generateVibrationLastFifteenDemo({meter_id: Number(params?.meter_id),}),
    "vibration/ai_analysis/all": (params) => generateVibrationAiAnalysisAllDemo({meter_id: params?.meter_id, page: params?.page, per_page: params?.per_page,}),
    "vibration/chart/month": (params) => generateVibrationChartMonthDemo({meter_id: params?.meter_id, year: Number(params?.year), month: Number(params?.month),}),
    "vibration/chart/year": (params) => generateVibrationChartYearDemo({meter_id: params?.meter_id, year: Number(params?.year),}),


    //UPS WHOLE BANK
    "bms/meters": () => generateBmsMetersDemo(),
    "bms/get_latest_data": (params) => generateBmsLatestDataDemo({meter_id: params?.meter_id}),
    "bms/line": (params) => generateBmsLineDemo({meter_id: params?.meter_id, start: params?.start, end: params?.end,}),

    //PUMP MS
    "pump_ms/get_latest_dashboard": () => generate_pump_latest_dashboard_demo(),
    "pump_ms/get_latest_data": (params) => generate_pump_latest_data_demo({ meter_id: params?.meter_id }),
    "pump_ms/analytics/line": (params) => generate_pump_analytics_line_demo({meter_id: Number(params?.meter_id), start_time: params?.start_time, end_time: params?.end_time,}),

    //BUSBAR MS
    "busbar_temp/location": () =>
        generate_busbar_locations_demo(),

    "busbar_temp/sensors": (params) =>
        generate_busbar_sensors_demo({
            location_id: Number(params?.location_id),
        }),

    "busbar_temp/get_latest_dashboard": () =>
        generate_busbar_latest_dashboard_demo(),

    "busbar_temp/get_latest_data": (params) =>
        generate_busbar_latest_data_demo({
            meter_id: Number(params?.meter_id),
        }),

    "busbar_temp/line" : (params) =>
        generate_busbar_line_demo({
            start: params.start,
            end: params.end,
        }),

    "busbar_temp/chart/year":(params) =>
        generate_busbar_year_chart_demo({
            year: Number(params.year),
        }),

    "busbar_temp/chart/month": (params) =>
        generate_busbar_month_chart_demo({
            year: Number(params.year),
            month: Number(params.month),
        }),

    // Temp OUTDOOR

    "aqi/outdoor_meters":  ()=>generate_outdoor_meters_demo(),
    "aqi/outdoor_get_latest_dashboard": () => generate_outdoor_latest_dashboard_demo(),
    "aqi/outdoor_get_latest_data": (params) => generate_outdoor_latest_data_demo({meter_id: params.meter_id,}),
    "aqi/outdoor_line": (params) =>
        generate_outdoor_line_chart_demo({
            start: params.start,
            end: params.end,
        }),

    "aqi/outdoor_chart/month": (params) =>
        generate_outdoor_month_chart_demo({
            year: Number(params.year),
            month: Number(params.month),
        }),

    "aqi/outdoor_chart/year": (params) =>
        generate_outdoor_year_chart_demo({
            year: Number(params.year),
        }),


    // "ems/chart/consumption/sankey/day": () =>
    //     generate_sankey_day_demo({
    //         day: 12,
    //         month: 2,
    //         year: 2026,
    //     }),
    //
    // "ems/status": () => generate_ems_status_demo(),
    //
    // "ems/get_datatable": (params) =>
    //     generate_ems_datatable_demo({
    //         meter_id: Number(params.meter_id),
    //     }),
    //
    // "ems/chart/consumption/bar/month": (params) =>
    //     generate_ems_month_bar_chart_demo({
    //         year: Number(params.year),
    //         month: Number(params.month),
    //         meter_id: Number(params.meter_id),
    //     }),

};
